import React from 'react';
import Hero from '../components/Hero';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import SitePartner from '../components/SitePartner';

const SchoolsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <Hero 
        title="School Cancellations" 
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773310180/school_oxnk1m.jpg"
      />
      <div className="max-w-2xl mx-auto px-4 mt-6">
        <SitePartner />
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white p-12 rounded-3xl shadow-xl border border-slate-100 text-center mt-4" >
          <h2 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter leading-tight"> Are schools open today? </h2>
          <a href="https://www.ocean100.com/storm-centre-2/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 w-full py-8 px-8 bg-green-600 hover:bg-green-700 text-white rounded-2xl transition-all shadow-xl active:scale-[0.97] text-3xl font-black text-center uppercase" >
            <span>Find Out Here</span>
            <SafeIcon name="ExternalLink" className="text-2xl" />
          </a>
          <p className="mt-8 text-slate-500 font-bold text-lg"> Check the official Ocean 100 Storm Centre for live updates. </p>
        </motion.div>
      </div>
    </div>
  );
};

export default SchoolsPage;